import React from 'react';
import { CalendarIcon, ClockIcon, MonitorIcon, TimerIcon, CheckCircle2Icon } from 'lucide-react';
import { useRegistration } from './RegistrationContext';
export const WebinarDetailsCard = () => {
  const {
    openPopup
  } = useRegistration();
  return <section className="mb-12" data-id="element-479">
      <div className="bg-blue-50 border border-blue-100 rounded-xl p-8" data-id="element-480">
        <div className="flex items-center gap-3 mb-6" data-id="element-481">
          <CalendarIcon className="w-6 h-6 text-blue-600" data-id="element-482" />
          <h3 className="text-xl font-bold text-gray-900" data-id="element-483">
            Het volgende <span className="text-blue-600" data-id="element-484">webinar</span>
          </h3>
        </div>

        <div className="space-y-5 mb-8" data-id="element-485">
          <div className="flex items-center" data-id="element-486">
            <CalendarIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-487" />
            <p className="text-lg text-gray-800" data-id="element-488">
              <span className="font-bold" data-id="element-489">Datum:</span> vandaag en morgen
            </p>
          </div>
          <div className="flex items-center" data-id="element-490">
            <ClockIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-491" />
            <p className="text-lg text-gray-800" data-id="element-492">
              <span className="font-bold" data-id="element-493">Tijd:</span> 10u, 13u, & 20u
            </p>
          </div>
          <div className="flex items-center" data-id="element-494">
            <MonitorIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-495" />
            <p className="text-lg text-gray-800" data-id="element-496">
              <span className="font-bold" data-id="element-497">Locatie:</span> Online (link wordt na
              registratie verstuurd)
            </p>
          </div>
          <div className="flex items-center" data-id="element-498">
            <TimerIcon className="w-6 h-6 text-blue-400 mr-4 flex-shrink-0" data-id="element-499" />
            <p className="text-lg text-gray-800" data-id="element-500">
              <span className="font-bold" data-id="element-501">Duur:</span> 90 minuten
            </p>
          </div>
          <div className="flex items-center" data-id="element-502">
            <CheckCircle2Icon className="w-6 h-6 text-green-500 mr-4 flex-shrink-0" data-id="element-503" />
            <p className="text-lg text-gray-800" data-id="element-504">
              <span className="font-bold" data-id="element-505">Kosten:</span> 100% GRATIS
            </p>
          </div>
        </div>

        <div className="bg-white border border-gray-200 rounded-lg p-5 mb-6" data-id="element-506">
          <p className="font-bold text-gray-900 mb-2 italic" data-id="element-507">Belangrijk:</p>
          <p className="text-gray-600 leading-relaxed" data-id="element-508">
            Er zijn beperkte plekken beschikbaar per uitzending. Elke maand
            melden zich meer mensen aan, dus reserveer snel je plek!
          </p>
        </div>

        <button onClick={openPopup} className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-4 px-6 rounded-xl transition-colors text-lg" data-id="element-509">
          RESERVEER MIJN PLEK - GRATIS AANMELDEN
        </button>
      </div>
    </section>;
};